import '@operato/dataset/ox-data-ooc-brief-view.js'
import '@things-factory/worklist/dist-client/components/activity-thread-timeline.js'

import gql from 'graphql-tag'
import { PropertyValues, html, css, nothing } from 'lit'
import { customElement, state } from 'lit/decorators.js'
import { PageView } from '@operato/shell'
import { i18next, localize } from '@operato/i18n'
import { client } from '@operato/graphql'

/**
 * 이 페이지는 여러개의 Data OOC를 한번에 프린트하기 위한 용도로 사용되는 페이지이다.
 */
@customElement('data-oocs-page')
export class DataOocsPage extends localize(i18next)(PageView) {
  static styles = [
    css`
      :host {
        display: block;
        overflow: auto;
      }

      activity-thread-timeline {
        margin: var(--spacing-medium);
      }

      .end {
        page-break-after: always;
        break-after: always;
      }
    `
  ]

  @state() dataOocs?: any[]

  get context() {
    return {
      title: i18next.t('title.data-ooc view')
    }
  }

  render() {
    return this.dataOocs?.map(dataOoc => {
      const reviewActivityThread = dataOoc?.reviewActivityInstance?.activityThreads?.[0]
      const resolveActivityThread = dataOoc?.resolveActivityInstance?.activityThreads?.[0]

      return html`
        <ox-data-ooc-brief-view .dataOoc=${dataOoc}></ox-data-ooc-brief-view>
        ${reviewActivityThread
          ? html`
              <activity-thread-timeline
                subtitle=${String(i18next.t('label.ooc review timeline'))}
                .activityThread=${reviewActivityThread}
                short-form
              ></activity-thread-timeline>
            `
          : nothing}
        ${resolveActivityThread
          ? html`
              <activity-thread-timeline
                subtitle=${String(i18next.t('label.ooc resolve timeline'))}
                .activityThread=${resolveActivityThread}
                short-form
              ></activity-thread-timeline>
            `
          : nothing}
        <div class="end"></div>
      `
    })
  }

  pageUpdated(changes: any, lifecycle: any, before: any) {
    if (this.active) {
      /*
       * this page is activated
       */
      const { ids = '' } = lifecycle.params

      this.fetchOocs(ids.split('|').map(id => id.trim()))
    } else {
      /* this page is deactivated */
    }
  }

  async fetchOocs(ids: string[]) {
    const filters = [
      {
        name: 'id',
        operator: 'in',
        value: ids
      }
    ]

    const response = await client.query({
      query: gql`
        query ($filters: [Filter!]) {
          dataOocs(filters: $filters) {
            items {
              id
              name
              description
              useCase
              dataSet {
                id
                name
              }
              key01
              key02
              key03
              key04
              key05
              partitionKeys
              dataItems {
                name
                description
                active
                hidden
                tag
                group
                type
                unit
                options
                quota
                spec
                stat
              }
              data
              rawData
              judgment
              ooc
              oos
              state
              history
              workDate
              workShift
              correctiveInstruction
              correctiveAction
              reviewedAt
              reviewer {
                id
                name
              }
              correctedAt
              corrector {
                id
                name
              }
              updater {
                id
                name
              }
              updatedAt
              collectedAt
              reviewActivityInstance {
                ...ActivityInstanceFragment
              }
              resolveActivityInstance {
                ...ActivityInstanceFragment
              }
            }
          }
        }

        fragment ActivityInstanceFragment on ActivityInstance {
          activityThreads {
            assignee {
              name
            }
            output
            activityApprovals {
              judgment
              approver {
                name
              }
              comment
              createdAt
              updatedAt
              terminatedAt
            }
            activityThreadHistories {
              transaction
              reason
              updater {
                name
              }
              updatedAt
              state
              output
            }
          }
        }
      `,
      variables: {
        filters
      }
    })

    this.dataOocs = response.data.dataOocs.items
  }
}
